import { render } from "./EditAccountHeader.vue?vue&type=template&id=f3e2749a"
import script from "./EditAccountHeader.vue?vue&type=script&lang=js"
export * from "./EditAccountHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__